module.exports = __webpack_public_path__ + "static/media/semi-circle-white.839e0d4d.svg";